// @ts-nocheck
/**
 * Layout route for all /team-leader/* pages.
 * Guards access to TeamLeader or SystemAdmin, plus ContentCreator on the assignments workspace only.
 */
import { createFileRoute, redirect, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/team-leader")({
  beforeLoad: async ({ context, location }) => {
    if (typeof window === "undefined") return;

    // Reuses the single token validation the parent _authenticated layout already performed for
    // this navigation, rather than issuing a second identical auth server-function call.
    const auth = context.auth;
    if (!auth?.userId) throw redirect({ to: "/login" });
    const { isSystemAdmin, isTeamLeader, isContentCreator } = auth;
    if (isSystemAdmin || isTeamLeader) return;

    // A ContentCreator authors assignment briefs (backend: AppRoles.AssignmentAuthoring, scoped to
    // the courses they authored), so the assignments workspace is theirs too — but only that one.
    // Every other /team-leader/* page reads groups, students or the grading queue, all of which the
    // API refuses them, so admitting them to the whole layout would just hand them empty screens.
    // The workspace itself hides the review queue for a caller who cannot grade.
    if (isContentCreator && location.pathname.startsWith("/team-leader/assignments")) return;

    throw redirect({ to: "/access-denied" });
  },
  component: () => <Outlet />,
});
